import React from 'react';
import { useDispatch } from 'react-redux';
import { getStaplesDesigns } from 'actions/designer';
import Button from 'components/Button';
import useStaplesArtFiles from 'pages/staples-art-files/context';
import { StaplesArtFilesProvider } from 'pages/staples-art-files/context';
import Tabs from 'pages/staples-art-files/Tabs';
import { Container, Header } from 'styles/pages/staples-art-files';

const Wrapper = () => {
  const dispatch = useDispatch();
  const { setValue } = useStaplesArtFiles();

  const fetchStaplesDesigns = async () => {
    const response = await dispatch(getStaplesDesigns());
    setValue(response);
  };

  return (
    <StaplesArtFilesProvider>
      <Container>
        <Header>
          <h1>Staples Art Files</h1>
          <Button
            title="Upload Art Files"
            onClick={() => {
              const myWidget = window.cloudinary.createUploadWidget(
                {
                  cloudName: 'big-oven-tees-inc',
                  uploadPreset: 'tnedst8q',
                  folder: 'STAPLES_ART',
                  clientAllowedFormats: ['dst', 'png', 'eps'],
                },
                (error, result) => {
                  if (!error && result && result.event === 'success') {
                    fetchStaplesDesigns();
                  }
                }
              );
              myWidget.open();
            }}
          />
        </Header>
        <Tabs searching={false} />
      </Container>
    </StaplesArtFilesProvider>
  );
};

const StaplesArtFiles = () => (
  <StaplesArtFilesProvider>
    <Wrapper />
  </StaplesArtFilesProvider>
);

export default StaplesArtFiles;
